import React from 'react'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'

export const ExpandableRadioButton = ({ label, value, disabled, children }) => {
  return null
}

export const ExpandableRadioGroup = ({ name, onChange, valueSelected, children, disabled = false, errorText = false, customClass = '' }) => {
  return (
  <div className="form-items-group">  
    {React.Children.map(children, child => (
      <div>
        <RadioGroup 
          className="form-item" 
          name={name} 
          onChange={onChange} 
          value={valueSelected}
        >
          <FormControlLabel 
            className={child.props.value === 'Accept' ? customClass : ''} 
            label={child.props.label} 
            value={child.props.value} 
            disabled={disabled || child.props.disabled} 
            control={<Radio />}
          />
        </RadioGroup>
        {valueSelected !== child.props.value ? null : child.props.children}
      </div>
    ))}
    {errorText ? <div className="form-error">{errorText}</div> : null}
  </div>
)}
